<template>
  <v-form ref="batchGroupForm" v-model="valid" lazy-validation>
    <v-container grid-list-xl text-xs-center>
      <v-flex class="mb-2 text-xs-left">
        <v-layout row wrap>
          <v-icon large>ti-calendar</v-icon>
          <h1 headline class="headText text-xs-left">Event agenda</h1>
          <v-layout justify-end align end>
            <v-btn
              @click="setNewAgendaItem"
              class="toggleBtnAgenda"
              round
              color="primary"
            >{{eventAgendaTitle}}</v-btn>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card v-if="newAgendaItem" class="innerCards elevation-0">
            <h2 class="text-xs-left ml-4">{{$translate('EVENT_AGENDA_NEW')}}</h2>
            <v-divider></v-divider>
            <v-card class="innerScrollableCards elevation-0">
              <v-layout row>
                <v-flex xs6 class="ml-4 mt-1">
                  <h3 class="text-xs-left">{{$translate('AVAILABLE')}}</h3>
                  <v-select
                    class="maxTextHeight"
                    :items="batchGroupType"
                    required
                    :disabled="userIsEditingBatchGroup || batchGroupForm.BatchGroupType !== undefined"
                    outline
                    v-model="batchGroupForm.BatchGroupType"
                    :rules="eventRule"
                  ></v-select>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_BG_TYPE_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs6 class="ml-4 mt-1">
                  <h3 class="text-xs-left">{{$translate('BATCHGROUP_NAME')}}</h3>
                  <v-text-field
                    class="maxTextHeight"
                    required
                    :disabled="userIsEditingBatchGroup"
                    outline
                    item-value="value"
                    v-model="batchGroupForm.Name"
                    :rules="eventRule"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoPositionTop" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_BG_TYPE_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout v-if="batchGroupForm.BatchGroupType == 'Specific'" row>
                <v-flex v-if="!userIsEditingBatchGroup" xs12 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_DATES_SELECTION')}}</h3>
                  <v-menu
                    ref="selectedDates"
                    v-model="selectedDates"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="Dates"
                    lazy
                    transition="scale-transition"
                    offset-y
                    :rules="eventRule"
                    full-width
                    readonly
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-combobox
                        class="maxTextHeight mb-4"
                        readonly
                        :rules="eventRule"
                        required
                        outline
                        hide-details
                        color="primary"
                        multiple
                        chips
                        small-chips
                        v-model="Dates"
                        :label="$translate('DATE')"
                        append-icon="event"
                        v-on="on"
                      ></v-combobox>
                    </template>
                    <v-date-picker first-day-of-week="1" v-model="Dates" multiple no-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        flat
                        color="primary"
                        @click="selectedDates = false"
                      >{{$translate('CANCEL')}}</v-btn>
                      <v-btn
                        flat
                        color="primary"
                        @click="$refs.selectedDates.save(Dates)"
                      >{{$translate('SAVE')}}</v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoPositionSelection" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_DATES_SEL_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout v-if="batchGroupForm.BatchGroupType == 'Repeating'" row>
                <v-flex xs11 class="BgInputfields ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_DAYS_SELECTION')}}</h3>
                  <v-select
                    class="maxTextHeight"
                    multiple
                    clearable
                    :disabled="userIsEditingBatchGroup"
                    :items="weekdays"
                    required
                    outline
                    v-model="Days"
                    :rules="eventRule"
                  ></v-select>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoPosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_DAYS_SEL_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout
                v-if="batchGroupForm.BatchGroupType == 'Repeating' && !userIsEditingBatchGroup"
                row
              >
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_START_DATE')}}</h3>
                  <v-menu
                    ref="startDateForm"
                    :close-on-content-click="true"
                    v-model="startDateForm"
                    :nudge-right="40"
                    :return-value.sync="tmpStartDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="computedDateFormattedStartDate"
                      :rules="eventRule"
                      required
                      outline
                      append-icon="event"
                      readonly
                      class="maxTextHeight"
                    ></v-text-field>
                    <v-date-picker
                      first-day-of-week="1"
                      v-model="tmpStartDate"
                      :min="nowDate"
                      @input="selectingTheDate(true, false)"
                      no-title
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_START_DATE_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_END_DATE')}}</h3>
                  <v-menu
                    ref="endDateForm"
                    :close-on-content-click="true"
                    v-model="endDateForm"
                    :nudge-right="40"
                    :return-value.sync="tmpEndDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="computedDateFormattedEndDate"
                      :rules="eventRule"
                      required
                      outline
                      append-icon="event"
                      readonly
                      class="maxTextHeight"
                    ></v-text-field>
                    <v-date-picker
                      :min="nowDate"
                      first-day-of-week="1"
                      v-model="tmpEndDateSuggested"
                      @input="selectingTheDate(false, true)"
                      no-title
                    />
                  </v-menu>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_END_DATE_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_START_TIME')}}</h3>
                  <v-text-field
                    :disabled="userIsEditingBatchGroup"
                    class="maxTextHeight"
                    type="time"
                    required
                    single-line
                    mask="time"
                    hint="Example: 08:30"
                    outline
                    append-icon="access_time"
                    v-model="batchGroupForm.StartTime"
                    :rules="eventRule"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_START_TIME_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_END_TIME')}}</h3>
                  <v-text-field
                    :disabled="userIsEditingBatchGroup"
                    class="maxTextHeight"
                    type="time"
                    required
                    mask="time"
                    hint="Example: 18:00"
                    single-line
                    outline
                    append-icon="access_time"
                    v-model="batchGroupForm.EndTime"
                    :rules="eventRule"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_END_TIME_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout v-if="eventForm.TimeWindowType == 'Repetitive'" row>
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_INTERVAL')}}</h3>
                  <v-text-field
                    v-if="eventForm.TimeWindowType == 'Repetitive'"
                    class="maxTextHeight"
                    required
                    :disabled="userIsEditingBatchGroup"
                    single-line
                    outline
                    append-icon="access_time"
                    v-model="batchGroupForm.BatchFrequency"
                    :rules="inputNumberRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_INTERVAL_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_MAX_INFLOW')}}</h3>
                  <v-text-field
                    v-if="eventForm.TimeWindowType == 'Repetitive'"
                    class="maxTextHeight"
                    required
                    :disabled="userIsEditingBatchGroup"
                    type="number"
                    single-line
                    outline
                    v-model="batchGroupForm.MaxInflow"
                    :rules="inputNumberRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_MAXINFLOW_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_RATE_PRICE')}}</h3>
                  <v-text-field
                    class="maxTextHeight"
                    type="number"
                    required
                    :disabled="userIsEditingBatchGroup"
                    single-line
                    outline
                    v-model="batchGroupForm.RatePrice"
                    :rules="inputNumberRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_RATE_PRICE_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
                <v-flex xs5 class="BgInputFieldsTime ml-4">
                  <h3 class="text-xs-left">{{$translate('EVENT_REWARD_POINTS')}}</h3>
                  <v-text-field
                    class="maxTextHeight"
                    type="number"
                    required
                    :disabled="userIsEditingBatchGroup"
                    single-line
                    outline
                    v-model="batchGroupForm.RewardPoints"
                    :rules="inputNumberRules"
                  ></v-text-field>
                </v-flex>
                <v-flex xs1>
                  <v-tooltip max-width="250" bottom>
                    <v-icon large class="infoTimePosition" slot="activator">info</v-icon>
                    <span>{{$translate('EVENT_REWARD_POINTS_INFO')}}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs5 class="bookingPolicyStyle flex ml-4">
                   <h3 class="text-xs-left">Booking Policy</h3>
                  <v-select
                    class="maxTextHeight"
                    v-if="!userIsEditingBatchGroup"
                    outline
                    :rules="eventRule"
                    label="Booking policy"
                    v-model="batchGroupForm.BookingPolicy"
                    :items="policies"
                    item-text="Name"
                    item-value="BookingPolicyId"
                    persistent-hint
                  ></v-select>
                  <v-text-field
                    v-else
                    label="Booking policy"
                    v-model="batchGroupForm.BookingPolicy.Name"
                    outline
                    :disabled="userIsEditingBatchGroup"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-flex xs11>
                <v-layout justify-left align-left>
                  <h4 text-xs-left class="ml-4">Price categories</h4>
                </v-layout>
                <v-card class="elevation-0 priceCategoriesCard">
                  <v-toolbar flat color="white">
                    <v-spacer></v-spacer>
                    <v-dialog v-model="priceCategoriesDialog" max-width="570px">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          :disabled="userIsEditingBatchGroup"
                          class="text-capitalize"
                          color="secondary"
                          round
                          @click="addNewPriceCategorie"
                          v-on="on"
                        >Add Price category</v-btn>
                      </template>
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formTicketTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md7>
                                <v-select
                                  v-if="newPriceCategorie"
                                  :disabled="!newPriceCategorie"
                                  v-model="editedPriceCategoriesItem.Name"
                                  :items="potentialPriceCategories"
                                  item-text="Name"
                                  label="Name"
                                  outline
                                ></v-select>
                                <v-text-field
                                  v-else
                                  disabled
                                  v-model="editedPriceCategoriesItem.Name"
                                  label="Name"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm6 md5>
                                <v-text-field
                                  input="number"
                                  min="0"
                                  max="100"
                                  v-model="editedPriceCategoriesItem.Price"
                                  label="Price"
                                ></v-text-field>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" round @click="closePriceCategoriesdialog">Cancel</v-btn>
                          <v-btn
                            color="primary"
                            :disabled="potentialPriceCategories.length == 0"
                            round
                            @click="savePriceCategories"
                          >Save</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-toolbar>
                  <v-data-table
                    :headers="priceCategoriesHeaders"
                    :items="batchgroupPriceCategories"
                    class="elevation-1"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.Name }}</td>
                      <td class="text-xs-center">{{ props.item.Price }}</td>
                      <td class="justify-center layout px-0">
                        <v-icon
                          :disabled="userIsEditingBatchGroup"
                          small
                          class="mr-2"
                          @click="editPriceCategories(props.item)"
                        >edit</v-icon>
                        <v-icon
                          :disabled="userIsEditingBatchGroup"
                          small
                          @click="deletePriceCategories(props.item)"
                        >delete</v-icon>
                      </td>
                    </template>
                  </v-data-table>
                </v-card>
              </v-flex>
              <v-layout v-if="!userIsEditingBatchGroup" row>
                <v-flex class="text-xs-left ml-4">
                  <v-btn round color="secondary" @click="resetBatchGroupObject">Clear</v-btn>
                </v-flex>
                <v-flex class="text-xs-right mr-4">
                  <v-btn round color="primary" @click="saveBatchGroup()">Add</v-btn>
                </v-flex>
              </v-layout>
              <v-layout v-else row>
                <v-flex class="text-xs-right mr-4">
                  <v-btn
                    round
                    color="primary"
                    @click="closeEditingBatchGroupMode(batchGroupForm)"
                  >Close</v-btn>
                </v-flex>
              </v-layout>
            </v-card>
          </v-card>
          <v-card v-else class="innerCards elevation-0">
            <h2 class="text-xs-left ml-4">Agenda overview</h2>
            <v-divider></v-divider>
            <v-card v-if="batchGroupList == 0" class="innerScrollableBatchGroupCards elevation-0">
              <strong text-xs-center>No agenda items available</strong>
            </v-card>
            <v-card v-else class="innerScrollableBatchGroupCards elevation-0">
              <v-card
                class="text-xs-left pl-1 elevation-0 batchGroupCards"
                v-for="(item,index) in batchGroupList"
                :key="index"
              >
                <v-flex v-if="item.Type == 'Repeating'">
                  <p>
                    <strong>Date:</strong>
                    {{item.StartDate}} - {{item.EndDate}}
                    <br>
                    <strong
                      v-if="item.StartTime.length == 5"
                    >Time: {{item.StartTime}} - {{item.EndTime}}</strong>
                    <strong
                      v-if="item.StartTime.length == 4"
                    >Time: {{setRightTime(item.StartTime)}} - {{setRightTime(item.EndTime)}}</strong>
                    <br>
                    <strong>Days:</strong>
                    {{item.JoinedDays}}
                    <br>
                    <strong>Rate price:</strong>
                    {{item.RatePrice}}
                    <br>
                    <strong>Points:</strong>
                    {{item.RewardPoints}},
                    <strong>Type:</strong>
                    {{item.Type}}
                  </p>
                </v-flex>
                <v-flex v-if="item.Type == 'Specific'">
                  <p>
                    <strong>Dates:</strong>
                    {{item.JoinedDates}}
                    <br>
                    <strong
                      v-if="item.StartTime.length == 5"
                    >Time: {{item.StartTime}} - {{item.EndTime}}</strong>
                    <strong
                      v-if="item.StartTime.length == 4"
                    >Time: {{setRightTime(item.StartTime)}} - {{setRightTime(item.EndTime)}}</strong>
                    <br>
                    <strong>Rate price:</strong>
                    {{item.RatePrice}}
                    <br>
                    <strong>Reward points:</strong>
                    {{item.RewardPoints}},
                    <strong>Type:</strong>
                    {{item.Type}}
                  </p>
                </v-flex>
                <v-btn
                  class="deleteBgButton"
                  color="primary"
                  icon
                  small
                  @click="showDeleteBGDialog(item)"
                >
                  <v-icon>delete_forever</v-icon>
                </v-btn>
              </v-card>
            </v-card>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="deleteBGDialog" max-width="290" hide-overlay>
      <v-card>
        <v-card-title class="headline">{{$translate('BATCHGROUP_DELETE')}}</v-card-title>
        <v-card-text>{{$translate('EVENT_DEL_AGENDA_ITEM')}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="secondary"
            @click.native="deleteBGDialog = false"
          >{{$translate('CANCEL')}}</v-btn>
          <v-btn round color="primary" @click.native="deleteBatchgroup()">{{$translate('YES')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="errorPriceCategoriesDialog" max-width="290" persistent>
      <v-card>
        <v-card-title class="headline">{{$translate('ERROR')}}</v-card-title>
        <v-card-text>Please add at least 1 price category to this batchgroup</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            round
            color="primary"
            @click="errorPriceCategoriesDialog = false"
          >{{$translate('NEXT')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import { ui_helpers } from "../shared/ui_helpers"; // Mandatory to reach the ShowComponents functions and other snippets
import appConfig from "../../config/app_config"; // Mandatory to reach the dss objects and other info
import * as dssRequest from "../api/dssRequest"; // Mandatory to do a request for data
import WizardBatchGroupObject from "@/objects/WizardBatchGroupObject.js"; // Mandatory to create the request object for batchgroups
import { objectToArray } from "@/shared/utility.js"; // Mandatory to create array of objects from object of objects
import BaseObject from "@/objects/BaseObject.js"; // Mandatory to create array of objects from objject of objects
import _ from "lodash"; // Mandatory to use the lodash accessibilities

export default {
  name: "EventWizard_EventAgenda",
  components: {
    // Importing the components that are used within this component
  },
  mixins: [ui_helpers],
  props: {
    newEventId: {
      type: String
    },
    eventForm: Object
  },
  computed: {
    eventAgendaTitle() {
      return this.newAgendaItem ? "View agenda items" : "New agenda item";
    },
    computedDateFormattedStartDate() {
      // format the start date for better visualisation of the date
      return this.formatDate(this.tmpStartDate);
    },
    computedDateFormattedEndDate() {
      // format the start date for better visualisation of the date
      return this.formatDate(this.tmpEndDateSuggested);
    },
    formTicketTitle() {
      return this.editedPriceCategoriesIndex === -1
        ? "New price categorie"
        : "Edit price categorie";
    }
  },
  watch: {
    priceCategoriesDialog(val) {
      val || this.closePriceCategoriesdialog();
    }
  },
  mounted() {
    console.log("eventForm", this.eventForm);
  },
  data() {
    return {
      // Variables
      newAgendaItem: false,
      valid: true,
      userIsEditingBatchGroup: false,
      editedItem: {},
      batchGroupToBeDelete: {},
      nowDate: new Date().toISOString().slice(0, 10),
      selectedDates: false,
      Dates: [],
      Days: [],
      batchGroupList: [],
      eventMessages: [],
      tmpStartDate: null,
      tmpEndDateSuggested: null,
      tmpEndDate: null,
      endDateForm: false,
      startDateForm: false,

      // Form objects
      batchGroupForm: {},

      // Price categories
      potentialPriceCategories: [],
      batchgroupPriceCategories: [],
      editedPriceCategoriesItem: {},
      editedPriceCategoriesIndex: -1,
      priceCategoriesDialog: false,
      newPriceCategorie: false,
      errorPriceCategoriesDialog: false,
      wrongDateDialog: false,
      priceCategoriesHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "Name"
        },
        { text: "Price", value: "Price", sortable: false },
        { text: "Actions", value: "Name", sortable: false }
      ],

      // Booking policies
      policies: [],


      // Dialogs
      deleteBGDialog: false,

      // Rules
      eventRule: [v => !!v || "This field is required"],
      inputNumberRules: [
        (v => !!v && v !== 0) || "This field is required",
        v => (v && v > -1) || "Must be 0 or higher"
      ],

      // Hard-coded !-- TODO make it dynamically --!
      batchGroupType: ["Specific", "Repeating"],
      weekdays: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"]
    };
  },
  created() {
    window.EventBus.listen("resetBatchGroupObject", this.resetBatchGroupObject);
    window.EventBus.listen(
      "getBatchGroupsForEvent",
      this.getBatchGroupsForEvent
    );
  },
  beforeDestroy() {
    window.EventBus.removeListener(
      "getBatchGroupsForEvent",
      this.getBatchGroupsForEvent
    );
  },
  methods: {
    getPolicies() {

      const payload = {
        EventId: this.eventForm.EventId
      };
      dssRequest.doRequest(
        response => {
          console.log("The gerenic call getPolicies was successful", response);
          this.policies = Object.values(response.data);
        },
        error => {
          console.log(
            "The generic call getPolicies was not successful",
            error
          );
        },
        "getPolicies",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    saveBatchGroup() {
      // Saving the batchgroup based on 'Specific' or 'Repeating' batchgroupType
      if (this.$refs.batchGroupForm.validate()) {
        console.log("validation is correct");
        if (
          this.batchGroupForm.BatchGroupType == "Repeating" &&
          (this.tmpStartDate == this.tmpEndDateSuggested ||
            this.tmpEndDateSuggested < this.tmpStartDate)
        ) {
          console.log("validation is not correct due to same time");

          let errorMessage =
            "Your end-date is the same as/earlier than the start-date, please change this and continue.";
          window.EventBus.fire("recievedTriggerForErrorDialog", errorMessage);
          return false;
        }
        const batchGroupData = {};
        this.batchGroupForm.EventId = Number(this.newEventId);
        this.batchGroupForm.LocationId = this.eventForm.LocationId;
        this.batchGroupForm.StartDate = this.tmpStartDate;
        this.batchGroupForm.EndDate = this.tmpEndDate;
        let toStorePriceCategories = {};

        if (this.batchgroupPriceCategories.length > 0) {
          this.batchgroupPriceCategories.forEach(e => {
            console.log("e", e.Id);
            toStorePriceCategories[Number(e.Id)] = {
              Price: Number(e.Price).toFixed(2)
            };
          });
          this.batchGroupForm.PriceCategories = toStorePriceCategories;
        } else {
          this.errorPriceCategoriesDialog = true;
          return;
        }

        if (this.eventForm.TimeWindowType == "Fixed") {
          // When the event is Fixed do this
          this.batchGroupForm.MaxInflow = Number(
            this.eventForm.MaxEventCapacity
          );
          this.batchGroupForm.BatchFrequency = 0;
          // Auto setting the batchhgroup duration based on the length of an event when timeWindow is fixed
          let getStartTimeHours = this.batchGroupForm.StartTime.split(":")
            .join("")
            .substr(0, 2);
          let getStartTimeSeconds = this.batchGroupForm.StartTime.split(":")
            .join("")
            .substr(2, 4);
          console.log(
            "get start thingies",
            getStartTimeHours,
            getStartTimeSeconds
          );
          let getEndTimeHours = this.batchGroupForm.EndTime.split(":")
            .join("")
            .substr(0, 2);
          let getEndTimeSeconds = this.batchGroupForm.EndTime.split(":")
            .join("")
            .substr(2, 4);
          let date1 = new Date(
            2000,
            0,
            1,
            Number(getStartTimeHours),
            Number(getStartTimeSeconds)
          );
          let date2 = new Date(
            2000,
            0,
            1,
            Number(getEndTimeHours),
            Number(getEndTimeSeconds)
          );
          if (
            this.batchGroupForm.EndTime < this.batchGroupForm.StartTime ||
            this.batchGroupForm.StartTime == this.batchGroupForm.EndTime
          ) {
            let secondErrorMessage =
              "Your end-time is the same as/earlier than the start-time, please change this and continue.";
            window.EventBus.fire(
              "recievedTriggerForErrorDialog",
              secondErrorMessage
            );
            return false;
          }
          console.log("this batchgroupForm", this.batchGroupForm);
        }
        if (
          this.batchGroupForm.BatchGroupType == "Specific" &&
          this.Dates.length != 0
        ) {
          //  Creating the specific batchgroup payload by using the .js file WizardBatchGroupObject
          // sort dates based on inserted ones
          this.Dates.sort((a, b) => {
            let a1 = a.split("-").join("");
            let b1 = b.split("-").join("");
            return a1 > b1 ? 1 : a1 < b1 ? -1 : 0;
          });
          this.batchGroupForm.Dates = this.Dates;
          console.log("specific on creation", this.batchGroupForm);
          this.batchGroupData = WizardBatchGroupObject._createSpecificBatchGroupObject(
            this.batchGroupForm
          );
        } else if (
          this.batchGroupForm.BatchGroupType == "Repeating" &&
          this.Days.length != 0
        ) {
          console.log(" repeating on creation", this.batchGroupForm);
          // Creating the repeating batchgroup payload by using the .js file WizardBatchGroupObject
          this.batchGroupForm.Days = this.Days;
          this.batchGroupData = WizardBatchGroupObject._createRepeatingBatchGroupObject(
            this.batchGroupForm
          );
        }
      } else {
        console.log("is it getting here");
        window.EventBus.fire("recievedTriggerForErrorDialog");
        return false;
      }
      let payload = this.batchGroupData;
      console.log("dit is de payload", this.batchGroupData);
      if (payload == undefined) {
        this.errorDialog = true;
      } else {
        payload.FunctionId = "EventFunctionLibrary::saveBatchGroup";

        // Add PartnerId to the request
        if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
          payload.PartnerId = -1;
        } else {
          payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
        }

        let responseData = Boolean;
        console.log("payload", payload);
        dssRequest.doRequest(
          response => {
            console.log(
              "The generic call for saveBatchGroup was successful",
              response
            );
            this.$refs.batchGroupForm.reset();
            responseData = true;
            this.Dates = [];
            this.Days = [];
            this.batchGroupData = {};
            this.batchGroupForm = {};
            this.tmpStartDate = null;
            this.tmpEndDate = null;
            this.tmpEndDateSuggested = null;
            this.getBatchGroupsForEvent(this.newEventId);
            this.newAgendaItem = false;
          },
          error => {
            console.log(
              "The generic call for saveBatchGroup was not successful",
              error
            );
            responseData = false;
            // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
          },
          "communicateWithDBLibrary",
          appConfig.dss.locationMgr,
          payload
        );
        if (responseData) {
          // Continue wizard on response
          return true;
        } else {
          // Fail wizard on error
          return false;
        }
      }
    },
    editBatchGroup(item) {
      item.BatchGroupType = item.Type;
      this.batchGroupForm = item;
      this.userIsEditingBatchGroup = true;
      console.log(" batchgroupLIst", this.batchGroupList);
    },
    deleteBatchgroup() {
      // Deleting a chosen batchgroup
      let payload = WizardBatchGroupObject._deleteRequestBatchgroup(
        this.batchGroupToBeDelete
      );

      // Add PartnerId to the request
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }

      dssRequest.doRequest(
        response => {
          console.log("The call deleteBatchGroup was successful", response);
          this.deleteBGDialog = false;
          this.getBatchGroupsForEvent(this.batchGroupToBeDelete.EventId);
        },
        error => {
          console.log("The call deleteBatchGroup", error);
        },
        "deleteBatchGroup",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    showDeleteBGDialog(item) {
      // opening the dialog to delete the chosen batchgroup
      this.batchGroupToBeDelete = item;
      this.deleteBGDialog = true;
    },
    resetBatchGroupObject() {
      this.$refs.batchGroupForm.reset();
      this.batchgroupPriceCategories = [];
    },
    closeEditingBatchGroupMode() {
      this.userIsEditingBatchGroup = false;
      this.batchGroupForm = this.editedItem;
      this.$refs.batchGroupForm.resetValidation();
      console.log("dit is de data", this.batchGroupList);
    },
    getBatchGroupsForEvent(eventId) {
      // Retrieving the batchgroups for the event
      let payload = {
        EventId: eventId,
        FunctionId: "EventFunctionLibrary::getBatchGroups"
      };

      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getBatchGroups was successful",
            response
          );
          delete response.data.ErrorMsg;
          this.batchGroupList = this.improvingOutputData(response.data);
          this.batchGroupList = objectToArray(this.batchGroupList);
        },
        error => {
          console.log(
            "The generic call getBatchGroups was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    improvingOutputData(data) {
      // Improving the visualition of the data fields to return to the user
      for (let [key, value] of Object.entries(data)) {
        value.BatchGroupId = key;
        if (value.hasOwnProperty("Dates")) {
          value.JoinedDates = Object.values(value.Dates).join(", ");
        }
        if (value.hasOwnProperty("StartDate")) {
          value.JoinedDays = Object.values(value.Days).join(", ");
        }
        if (value.hasOwnProperty("BatchFrequency")) {
          value.BatchFrequency = value.BatchFrequency / 60;
        }
        if (value.hasOwnProperty("Days")) {
          value.selectedDaysArray = [];
          value.selectedDays = "";
          for (let [innerKey, innerValue] of Object.entries(value.Days)) {
            console.log("Key value", innerKey, innerValue);
            value.selectedDaysArray.push(innerValue);
          }
          value.selectedDays = value.selectedDaysArray.toString();
          console.log("value selected days", value.selectedDays);
        } else {
        }
      }

      return data;
    },
    selectingTheDate(startDateInput = false, endDateInput = false) {
      // Selecting the date for the start and end date input
      if (startDateInput && !endDateInput) {
        this.$refs.startDateForm.save(this.tmpStartDate);
        if (this.tmpEndDateSuggested == null) {
          this.tmpEndDateSuggested = this.tmpStartDate;
        }
      } else if (!startDateInput && endDateInput) {
        this.$refs.endDateForm.save(this.tmpEndDateSuggested);
        this.tmpEndDate = this.tmpEndDateSuggested;
      }
    },
    formatDate(date) {
      // Formatting the date to right output
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    setRightTime(time) {
      let timeArray = [];
      timeArray[0] = time.slice(0, 2);
      timeArray[1] = ":";
      timeArray[2] = time.slice(2, 4);
      timeArray = timeArray.join("");
      console.log("timeArray", timeArray);
      return timeArray;
    },
    setNewAgendaItem() {
      this.newAgendaItem
        ? (this.newAgendaItem = false)
        : (this.newAgendaItem = true);
      if (this.newAgendaItem) {
        this.getPolicies();
        this.resetBatchGroupObject();
      }
    },
    addNewPriceCategorie() {
      this.getPriceCategories();
      this.newPriceCategorie = true;
    },
    editPriceCategories(item) {
      this.editedPriceCategoriesIndex = this.batchgroupPriceCategories.indexOf(
        item
      );
      this.editedPriceCategoriesItem = Object.assign({}, item);
      this.priceCategoriesDialog = true;
    },
    deletePriceCategories(item) {
      const index = this.batchgroupPriceCategories.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.batchgroupPriceCategories.splice(index, 1);
    },
    closePriceCategoriesdialog() {
      this.priceCategoriesDialog = false;
      this.newPriceCategorie = false;
      setTimeout(() => {
        this.editedPriceCategoriesItem = Object.assign(
          {},
          this.defaulPriceCategoriestItem
        );
        this.editedPriceCategoriesIndex = -1;
      }, 300);
    },
    savePriceCategories() {

      if (this.editedPriceCategoriesIndex > -1) {
        Object.assign(
          this.batchgroupPriceCategories[this.editedPriceCategoriesIndex],
          this.editedPriceCategoriesItem
        );
      } else {
        this.potentialPriceCategories.forEach(e => {
          if (this.editedPriceCategoriesItem.Name == e.Name) {
            this.editedPriceCategoriesItem.Id = e.Id;
          }
        });
        this.batchgroupPriceCategories.push(this.editedPriceCategoriesItem);
      }
      this.closePriceCategoriesdialog();
    },
    getPriceCategories() {

      const payload = {
        EventId: this.eventForm.EventId
      };
      dssRequest.doRequest(
        response => {
          console.log(
            "The generic call getPriceCategories was successful",
            response
          );
          this.potentialPriceCategories = [];
          if (!_.isEmpty(response.data.Tickets)) {
            if (this.batchgroupPriceCategories.length == 0) {
              for (let [key, value] of Object.entries(response.data.Tickets)) {
                // this.potentialPriceCategories.push({ key, ...value });
                this.potentialPriceCategories.push(value);
              }
            } else {
              for (let [key, value] of Object.entries(response.data.Tickets)) {
                let alreadyInside = false;
                for (let [
                  elementKey,
                  element
                ] of this.batchgroupPriceCategories.entries()) {
                  console.log("element and value: ", element, value);
                  if (element.Id == value.Id) {
                    alreadyInside = true;
                    break;
                  }
                }
                console.log("alreadyInside: ", alreadyInside);
                if (!alreadyInside) {

                  this.potentialPriceCategories.push(value);
                }
              }
            }
          } else {
            console.log(" recieved data is empty");
          }
        },
        error => {
          console.log(
            "The generic call getPriceCategories was not successful",
            error
          );
        },
        "getPriceCategories",
        appConfig.dss.eventAdminMng,
        payload
      );
    }
  }
};
</script>


<style lang = "scss", scoped>
.headText {
  margin-top: 1em;
  margin-left: 2em;
  margin-bottom: 1em;
}

.maxTextHeight {
  margin-top: -0.5em !important;
  transform: scale(0.85);
  transform-origin: left;
}

.infoPositionTop {
  margin-left: -2.8em;
  margin-bottom: -1.2em;
}

.infoPosition {
  margin-left: -5.8em;
  margin-top: -1.4em;
}

.infoPositionSelection {
  margin-left: -4em;
  margin-top: -1.4em;
}

.infoTimePosition {
  margin-left: -1.5em;
  margin-top: -1em;
}

.innerCards {
  max-height: calc(45vh) !important;
  margin-bottom: 2em;
  min-height: 20em;
  border: 1px solid black !important;
  border-radius: 3em !important;
}

.innerScrollableCards {
  margin-top: 0.5em;
  margin-right: 0.5em;
  margin-bottom: 2em !important;
  max-height: calc(37vh) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.batchGroupCards {
  max-height: 9em !important;
  margin-left: 0.3em;
  margin-top: 0.3em;
  margin-bottom: 0.1em !important;
  max-width: 95% !important;
  background-color: #c0ccdf !important;
  border-radius: 1em !important;
  border: 1px solid black !important;
}

.innerScrollableBatchGroupCards {
  margin-top: 0.5em;
  margin-right: 0.5em;
  margin-bottom: 2em !important;
  min-height: calc(37vh) !important;
  max-height: calc(37vh) !important;
  overflow-y: auto;
  overflow-x: hidden;
}

.maxBGTextHeight {
  margin-top: -0.5em !important;
  transform: scale(0.8);
  transform-origin: left;
}

.BgInputfields {
  margin-top: -2em;
}

.BgInputFieldsTime {
  margin-top: -3em;
  margin-right: -3em;
  margin-left: 1.5em !important;
}

.deleteBgButton {
  margin-left: 85% !important;
  margin-top: -27%;
}

.editBgButton {
  margin-left: 85% !important;
  margin-top: -70%;
}

.toggleBtnAgenda {
  margin-right: 2em;
  margin-bottom: 1em;
  margin-top: -1em;
}

.priceCategoriesCard {
  margin-right: -1.5em;
  margin-left: -0.3em;
  border: 1px solid black !important;
}
.bookingPolicyStyle {
  margin-top: -3em;
}
/** checks if the media window is maximum 800px **/
@media (max-height: 800px) {
  .innerCards {
    max-height: calc(45vh) !important;
    min-height: 20em;
  }
}

/** checks if the media window is minimal 900px **/
@media (min-height: 900px) {
  .innerCards {
    max-height: calc(50vh) !important;
    min-height: 20em;
  }
}
</style>
